import GetClientConfigWrapper from './GetClientConfigWrapper';

export default GetClientConfigWrapper;
